import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { SuccessToast, ErrorToast } from "../../../components/toast/Toasts";
import { IServiceLocation } from "../serviceLocationModel";

export const getAllServiceLocation = createAsyncThunk(
  "ServiceLocation/FindAllServiceLocation",
  async (formData: { CityName: string }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ServiceLocation/FindAllServiceLocation`,
        formData
      );
      return response.data?.Data as IServiceLocation[];
    } catch (error: any) {
      console.error("Error Fetching Service Locations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveServiceLocation = createAsyncThunk(
  "ServiceLocation/FindAllActiveServiceLocation",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ServiceLocation/FindAllActiveServiceLocation`
      );
      return response.data?.Data as IServiceLocation[];
    } catch (error: any) {
      console.error("Error Fetching Active Service Locations:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createServiceLocation = createAsyncThunk(
  "ServiceLocation/InsertServiceLocation",
  async (serviceLocationData: IServiceLocation) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ServiceLocation/InsertServiceLocation`,
        serviceLocationData
      );
      SuccessToast(response.data?.Details || "Service Location created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Service Location:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateServiceLocation = createAsyncThunk(
  "ServiceLocation/UpdateServiceLocation",
  async (serviceLocationData: IServiceLocation) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ServiceLocation/UpdateServiceLocation`,
        serviceLocationData
      );
      SuccessToast(response.data?.Details || "Service Location updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Service Location:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteServiceLocation = createAsyncThunk(
  "ServiceLocation/DeleteServiceLocation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ServiceLocation/DeleteServiceLocation`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Service Location deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Service Location:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getServiceLocationByID = createAsyncThunk(
  "ServiceLocation/FindByIDServiceLocation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ServiceLocation/FindByIDServiceLocation`,
        { ID }
      );
      return response.data?.Data as IServiceLocation;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Service Location:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const activeInactiveServiceLocation = createAsyncThunk(
  "ServiceLocation/ActiveInActiveServiceLocation",
  async (formData: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ServiceLocation/ActiveInActiveServiceLocation`,
        formData
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Service Location:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
